export default "__VITE_ASSET__CITRQGoC__"